module.exports = __webpack_public_path__ + "img/small-1.bbf035f6.webp";